import {ResolveFn} from '@angular/router';
import {inject} from '@angular/core';
import {RenderStrategy} from '../../enums/render-strategy';
import {RouteService} from '../route.service';
import {PointOfInterestService} from '../point-of-interest.service';
import {CategoryService} from '../category.service';

export const routesIndexResolver: ResolveFn<Promise<Awaited<undefined | void>[]>> = () => {
  return Promise.all([
    inject(RouteService).resolveIndex(RenderStrategy.PREFER_SERVER),
    inject(CategoryService).resolveIndex(RenderStrategy.PREFER_SERVER),
    inject(PointOfInterestService).resolveIndex(RenderStrategy.PREFER_SERVER),
  ]);
};
